export const getModuleItems = (state) => state.modules.modules;

export const getSelectedModule = (state) => state.modules.selectedModule;
